import { lazy } from 'react';
import { Outlet, Route } from 'react-router-dom';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';
import Authorize from 'main/auth/Authorize';
import RepairsSectionPage from 'pages/drivelineview/sectionPages/Services/RepairsSectionPage';
import ServiceAreaPage from 'pages/drivelineview/sectionPages/ServiceAreaPage';

import { PageRedirect } from './PageRedirect';
import LazyRouteElement from './common/LazyRoute';
import {
	Drivelineview_Services_Repairs,
	Drivelineview_Services_ServiceProtocols,
	drivelineviewComponentsAndSoftware,
	drivelineviewServiceArea,
	drivelineviewSoftwareParameters,
	drivelineviewVariants,
	drivelineviewWarranty,
} from './urls/RouteUrls';

const DrivelineviewPage = lazy(
	() => import('pages/drivelineview/DrivelineviewPage')
);
const WarrantySection = lazy(
	() => import('pages/drivelineview/sectionPages/WarrantySectionPage')
);
const VariantsSection = lazy(
	() => import('pages/drivelineview/sectionPages/VariantsSectionPage')
);
const ComponentsAndSoftwareSection = lazy(
	() =>
		import(
			'pages/drivelineview/sectionPages/ComponentsAndSoftwareSectionPage'
		)
);
const SoftwareParametersSection = lazy(
	() =>
		import('pages/drivelineview/sectionPages/SoftwareParametersSectionPage')
);
const ServiceProtocolsSection = lazy(
	() => import('pages/drivelineview/sectionPages/Services/ServiceProtocolsSectionPage')
);

export const getDrivelineviewRoutes = (): React.JSX.Element[] => [
	<Route
		key={'drivelineview'}
		element={
			<Authorize area={createArea(AreaName.Unit, OperationType.Read)}>
				<Outlet />
			</Authorize>
		}>
		<Route
			element={
				<LazyRouteElement
					Component={DrivelineviewPage}
					path={'drivelineview'}
				/>
			}>
			<Route
				index
				element={<PageRedirect url={drivelineviewServiceArea} />}
			/>
			<Route
				element={
					<LazyRouteElement
						Component={WarrantySection}
						path={drivelineviewWarranty}
					/>
				}
				path={drivelineviewWarranty}
			/>
			<Route
				element={
					<LazyRouteElement
						Component={VariantsSection}
						path={drivelineviewVariants}
					/>
				}
				path={drivelineviewVariants}
			/>
			<Route
				element={
					<LazyRouteElement
						Component={ComponentsAndSoftwareSection}
						path={drivelineviewComponentsAndSoftware}
					/>
				}
				path={drivelineviewComponentsAndSoftware}
			/>
			<Route
				element={
					<LazyRouteElement
						Component={SoftwareParametersSection}
						path={drivelineviewSoftwareParameters}
					/>
				}
				path={drivelineviewSoftwareParameters}
			/>
			<Route
				path={drivelineviewServiceArea}
				element={<ServiceAreaPage />}>
				<Route
					index
					element={
						<PageRedirect
							url={Drivelineview_Services_ServiceProtocols}
						/>
					}
				/>
				<Route
					path={Drivelineview_Services_ServiceProtocols}
					element={
						<LazyRouteElement
							Component={ServiceProtocolsSection}
							path={Drivelineview_Services_ServiceProtocols}
						/>
					}
				/>
				<Route
					path={Drivelineview_Services_Repairs}
					element={<RepairsSectionPage />}
				/>
			</Route>
		</Route>
		{/** Left for compatibility, as this was previously a separate route */}
		<Route
			path={Drivelineview_Services_ServiceProtocols}
			element={
				<PageRedirect
					url={`../${drivelineviewServiceArea}/${Drivelineview_Services_ServiceProtocols}`}
				/>
			}
		/>
	</Route>,
];
